export default {
      id: "volume-on-usage",
      viewBox: "0 0 14 13",
      url: __webpack_public_path__ + "img/icons.479460d5.svg#volume-on",
      toString: function () {
        return this.url;
      }
    }